import { render, staticRenderFns } from "./addTogetherToken.vue?vue&type=template&id=05fd8c06&scoped=true"
import script from "./addTogetherToken.vue?vue&type=script&lang=js"
export * from "./addTogetherToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd8c06",
  null
  
)

export default component.exports